import { onBeforeUnmount, onMounted, ref, watch } from 'vue';

// Fullscreen is an overlay of our own (position: fixed over the page), not the
// browser's Fullscreen API: iOS has none, and the card, legend and controls
// simply come along because they live inside .listing-map. The container
// ResizeObserver in the map picks up the new size.
const BODY_CLASS = 'has-fullscreen-map';

export const useMapFullscreen = ({ getMap, canClose }) => {
  const fullscreen = ref(false);

  const toggleFullscreen = () => {
    fullscreen.value = !fullscreen.value;
  };

  watch(fullscreen, (value) => {
    document.body.classList.toggle(BODY_CLASS, value);
    // Cooperative gestures exist because the map sits in a scrolling page; in
    // the overlay there is nothing else to scroll, so the map takes the wheel
    // and the single finger
    const map = getMap();
    if (value) map?.cooperativeGestures?.disable();
    else map?.cooperativeGestures?.enable();
  });

  // Capture phase, registered at map mount and so before any card mounts: this
  // runs first and can leave Escape to an open card or detail panel
  const onKeydown = (event) => {
    if (event.key !== 'Escape' || !fullscreen.value || !canClose()) return;
    fullscreen.value = false;
  };

  onMounted(() => {
    document.addEventListener('keydown', onKeydown, { capture: true });
  });

  onBeforeUnmount(() => {
    document.removeEventListener('keydown', onKeydown, { capture: true });
    document.body.classList.remove(BODY_CLASS);
  });

  return { fullscreen, toggleFullscreen };
};
